// src/hooks/useLearners.js
import { message } from "antd";
import newEmployeesService from "PlatForms/OrgLMS/Services/ManagerService/newEmployeesService";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const useNewEmployees = (token) => {
  const [learners, setLearners] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [loadingRowId, setLoadingRowId] = useState(null);
  const [pagination, setPagination] = useState({
    totalCount: 0,
    pageNumber: 1,
    pageSize: 10,
    totalPages: 1,
  });

  const fetchLearners = async (page = 1) => {
    try {
      setLoading(true);
      const data = await newEmployeesService.getUnassignedLearners(token, {
        pageNumber: page,
        pageSize: pagination.pageSize,
      });
      setLearners(data.items || []);
      setPagination({
        totalCount: data.totalCount,
        pageNumber: data.pageNumber,
        pageSize: data.pageSize,
        totalPages: data.totalPages,
      });
    } catch (error) {
      console.error("Error fetching learners:", error);
      message.error("Failed to load employees. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    fetchLearners(page);
  };

  const pickLearner = async (learnerId) => {
    try {
      setLoadingRowId(learnerId);
      await newEmployeesService.pickLearnerByManager(learnerId, token);
      message.success("Assign as Employee Successfully");
      navigate("/employees");
      fetchLearners();
    } catch (error) {
      console.error("Error picking learner:", error);
    } finally {
      setLoadingRowId(null);
    }
  };

  useEffect(() => {
    fetchLearners();
  }, []);

  return {
    learners,
    loading,
    loadingRowId,
    pickLearner,
    pagination,
    handlePageChange,
  };
};

export default useNewEmployees;
